export class SessionStorageKeys {
    public static readonly UserInfo: string = 'USER_INFORMATION';
}

export class LocalStorageKeys {
    public static readonly IsUserLoggedIn: string = "IS_USER_LOGGED_IN";
    public static readonly AccessTokenExpiryKey: string = "SESSION_ID_EXPIRATION";
    public static readonly RefreshTokenExpiryKey: string = "REMEMBER_USER_TOKEN_EXPIRATION";
    public static readonly TransactionKey: string = "TRANSACTION_PERSISTENCE_KEY"
    public static readonly AgencySignupKey: string ="AGENCY_SIGNUP_PERSISTENCE_KEY"
}